import { faComment, faThumbsUp as farThumbsUp } from "@fortawesome/pro-regular-svg-icons";
import { faCircle, faThumbsUp as fasThumbsUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { ImgCropMode, ImgCropped } from "@/mk2/components/ImgCropped";

import styles from "./AlbumImagePreview.mscss";

interface OwnProps {
    photoUrl: string;
    photoWidth: number;
    photoHeight: number;
    createdTime?: string;
    complaintsCount: number;
    commentsCount: number;
    likesCount: number;
    isLiked: boolean;
    previewWidth: number;
    previewHeight: number;
    className?: string;
}

type Props = OwnProps;

export default class AlbumImagePreview extends React.Component<Props> {
    public render() {
        const {
            photoUrl,
            photoWidth,
            photoHeight,
            createdTime,
            complaintsCount,
            commentsCount,
            likesCount,
            isLiked,
            previewWidth,
            previewHeight,
            className,
        } = this.props;
        const d1 = new Date(createdTime);
        const d2 = new Date();
        const createdToday =
            d1.getDate() === d2.getDate() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getFullYear() === d2.getFullYear();

        return (
            <div className={cx(styles.AlbumImagePreview, className)}>
                <ImgCropped
                    mode={ImgCropMode.Cover}
                    imgUrl={photoUrl}
                    alt=""
                    imgWidth={photoWidth}
                    imgHeight={photoHeight}
                    width={previewWidth}
                    height={previewHeight}
                />
                {createdToday && (
                    <div className={styles.AlbumImagePreview__todayBadge}>
                        <FontAwesomeIcon icon={faCircle} />
                    </div>
                )}
                {complaintsCount > 0 && (
                    <div className={styles.AlbumImagePreview__complaintsBadge}>
                        <FontAwesomeIcon icon={faCircle} />
                    </div>
                )}
                {commentsCount + likesCount > 0 && (
                    <div
                        className={cx(
                            styles.AlbumImagePreview__info,
                            complaintsCount === 0
                                ? styles["AlbumImagePreview__info--no-complaints"]
                                : styles["AlbumImagePreview__info--complaints"],
                        )}
                    >
                        {likesCount ? (
                            <span className={styles.AlbumImagePreview__info__likes}>
                                {likesCount}{" "}
                                {isLiked ? (
                                    <FontAwesomeIcon icon={fasThumbsUp} />
                                ) : (
                                    <FontAwesomeIcon icon={farThumbsUp} />
                                )}
                            </span>
                        ) : null}
                        {commentsCount ? (
                            <span className={styles.AlbumImagePreview__info__comments}>
                                {commentsCount} <FontAwesomeIcon icon={faComment} />
                            </span>
                        ) : null}
                    </div>
                )}
            </div>
        );
    }
}
